import { HttpClient, HttpParams } from '@angular/common/http';
import {
  Component,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CaseView } from '../../models/caseview.model';

import { TranslateService } from '@ngx-translate/core';

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}

@Component({
  selector: 'app-return-to-initiator',
  templateUrl: './return-to-initiator.component.html',
  styleUrls: ['./return-to-initiator.component.scss'],
})
export class ReturnToInitiatorComponent implements OnInit {
  @ViewChild('initiatorTemplate') initiatorTemplate: TemplateRef<any>;
  loadGrid = false;
  selectedInitiators = null;
  isSelected = false;

  singleData = {
    docId: null,
    alphanum_Fileno: null,
    process: null,
    initiator: null,
    message: null,
  };

  caseData: any = [];

  refIdList = '';

  message;

  pageSize = 3;
  rows = [];
  cols: { [key: string]: unknown }[] = [
    {
      columnName: 'File No.',
      columnId: 'fileno',
      width: '150',
      displayable: true,
    },
    {
      columnName: 'Process',
      columnId: 'process',
      width: '120',
      displayable: true,
    },
    {
      columnName: 'Initiator',
      columnId: 'initiator',
      width: '100',
      displayable: true,
    },
  ];

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ReturnToInitiatorComponent>,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.translate
      ?.get('Return_to_Initiator.message')
      ?.subscribe((res) => (this.message = res));
    this.onLoad();
  }

  onLoad() {
    this.caseData = this.data?.selectedData;

    for (const s of this.caseData) {
      this.refIdList += String(s.docId) + ',';
    }
    this.refIdList = this.refIdList.slice(0, -1);
    let params = new HttpParams();
    //params = params.append('appTypeId', '1');
    params = params.append('appTypeId', this.caseData[0].appTypeId);
    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '10000080');

    this.http
      .get('/workflow/hierarchy-details-revert', { params: params })
      .subscribe((res) => {
        const restemp: any = res;
        if (!restemp.data.length) {
          this.singleData.message = 'Details not found';
        } else {
          for (const val of this.caseData) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;

            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH = s.fileHierarchyVOArr;
                if (!fileH) {
                  this.singleData.initiator = this.message;
                } else {
                  for (const m of fileH) {
                    const recep = {
                      empName: m.empName,
                      unitId: m.unitId,
                      unitName: m.unitName,
                      toOrderNo: m.unitLevel,
                      mpgType: m.mpgTyp,
                      roleId: m.nextRole,
                    };
                    this.singleData.initiator = recep;
                  }
                }
              }
            }
            let row;
            row = {
              docId: this.singleData.docId,
              fileno: this.singleData.alphanum_Fileno,
              process: this.singleData.process,
              initiator: this.singleData.initiator,
            };
            this.rows.push(row);
            this.cols.forEach((c) => {
              if (c?.columnId === 'initiator') {
                c.template = this.initiatorTemplate;
              }
            });
            this.singleData = {
              docId: null,
              alphanum_Fileno: null,
              process: null,
              initiator: null,
              message: null,
            };
          }
        }

        this.loadGrid = true;
      });
  }

  onSend(): void {
    let postData = {
      refId: [],
      toUnit: [],
      toOrderNo: [],
      roleId: [],
      toMpgType: [],
      applTypeId: this.caseData[0].appTypeId,
      actionSentDate: '03-Dec-2020',
      actionDlvrDate: '03-Dec-2020',
      movmentActionFlag: 4,
      fromGrpId: null,
      toGrpId: null,
      fromType: null,
      toType: null,
      toRoleId: null,
      delegationVO: null,
      fromGrpWS: null,
      groupLevel: null,
      groupUnitId: null,
      groupId: null,
      recall: null,
      papsFlag: false,
      line: null,
    };
    for (let item in this.selectedInitiators) {
      postData.refId.push(this.selectedInitiators[item]?.docId);
      postData.toUnit.push(this.selectedInitiators[item].initiator?.unitId);
      postData.toOrderNo.push(
        this.selectedInitiators[item].initiator?.toOrderNo
      );
      postData.toMpgType.push(this.selectedInitiators[item].initiator?.mpgType);
      postData.roleId.push(this.selectedInitiators[item].initiator?.roleId);
    }

    if (!this.data?.isFromCustomAction) {
      this.http.post('/workflow/workflow-operation', postData).subscribe(
        (res) => {
          this.dialogRef.close(true);
        },
        (error) => {
          this.dialogRef.close(false);
        }
      );
    } else {
      this.dialogRef.close(postData);
    }
  }

  onRowSelection(selectedRows) {
    this.isSelected = selectedRows.length != 0 ? true : false;
    this.selectedInitiators = selectedRows;
  }
}
